import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'health_clinics'

export const dataPointDefinition = {
  retracedId: 'health_clinics',
  name: 'Health clinics',
  description: '',
  meta: {
    slcpMeta: {
      key: 'gr-2--1-2x',
      number: 'WI-GRI-6-2',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'wi-gri-4',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],gr-2,Yes',
      machineShowHide: '[2],gr-2,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'gr-2--1-2x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29120,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
